import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import Fonts from '../../../fonts/';
import { useActionExectioner } from '../../core/actions';

import { getColorsConfig } from '../../../../components/AssetViewer/helper/cssHelper';

import styles from './menuContainer.module.scss';


const MenuButtonComponent = ({ className, widgetProps, breakpoint, menuContent }) => {
  const trayBackground = breakpoint !== 'mobile' ? 'rgba(255, 255, 255, 0)' : getColorStyles(_.get(widgetProps, `properties.${breakpoint}.trayBackground`))
  Fonts.useFont(_.get(widgetProps, 'fonts') || []);

  return (
    <div
      className={cx(className,
        { [styles.buttonContainer]: breakpoint === 'desktop' },
        { [styles.verticalView]: breakpoint === 'mobile' },
      )}
      style={{ backgroundColor: trayBackground }}
    >
      {
        (menuContent || []).map((menu, index) => {
          if (menu.children && menu.children.length > 0) {
            return <DropdownMenu index={index} key={index} menu={menu} contentLength={menuContent.length} widgetProperties={widgetProps} breakpoint={breakpoint} />
          } else {
            return <MenuItem index={index} key={index} menu={menu} contentLength={menuContent.length} widgetProperties={widgetProps} breakpoint={breakpoint} />
          }
        })
      }
    </div>
  );
};

const MenuItem = ({ menu, contentLength, index, breakpoint, widgetProperties }) => {
  const actionExcutioner = useActionExectioner();
  const [buttonStyles, setButtonStyles] = useState({});
  const widgetProps = _.get(widgetProperties, 'properties');

  const action = _.get(menu, 'action');

  const handleClick = (e) => {
    if (action) {
      e.stopPropagation();
      actionExcutioner.execute(widgetProperties, action);
    }
  }

  useEffect(() => {
    updateButtonStyles('regular');
  }, [breakpoint, widgetProperties]);

  const updateButtonStyles = (state) => {
    const updatedStyle = getStyles(widgetProps, breakpoint, state);
    setButtonStyles(updatedStyle);
  }

  return (
    <div
      key={index}
      className={cx(styles.menuButton, { [styles.lastButton]: index === contentLength - 1 })}
      style={buttonStyles}
      onClick={handleClick}
      onMouseOver={() => updateButtonStyles('hover')}
      onMouseOut={() => updateButtonStyles('regular')}
    >
      {menu.name}
    </div>
  )
}

const DropdownMenu = ({ menu, contentLength, index, widgetProperties, breakpoint }) => {
  const widgetProps = _.get(widgetProperties, 'properties');
  const subMenuRef = useRef();
  const [state, setState] = useState({
    buttonStyle: {},
    showDropdown: false,
    active: 'regular'
  })

  useEffect(() => {
    const activeButtonStyle = getStyles(widgetProps, breakpoint, 'regular');
    setState((state) => {
      return {
        ...state,
        buttonStyle: activeButtonStyle,
        showDropdown: false
      }
    })

  }, [breakpoint, widgetProperties]);


  const handleOnMouseOver = (show, active) => {
    let updatedStyle = getStyles(widgetProps, breakpoint, active);

    setState((state) => {
      return {
        ...state,
        buttonStyle: updatedStyle,
        showDropdown: show,
        active: active
      }
    })

  }

  const toggleDropDown = (show) => {
    let updatedStyle = getStyles(widgetProps, breakpoint, show ? 'hover' : 'regular');

    setState((state) => {
      return {
        ...state,
        buttonStyle: updatedStyle,
        showDropdown: show,
        active: show ? 'hover' : 'regular'
      }
    })
  }

  const adjustSubMenuPosition = () => {
    const submenuRect = subMenuRef.current.getBoundingClientRect();
    const overFlowLeft = Math.round(submenuRect.left);
    const overFlowRight = (overFlowLeft + subMenuRef.current.scrollWidth);

    if (overFlowRight > window.innerWidth) {
      //Apply the translateX value to the submenu's transform property
      subMenuRef.current.style.transform = `translateX(-${overFlowRight - window.innerWidth}px)`;
    }
  }

  useEffect(() => {
    if (state.showDropdown && breakpoint == 'desktop') {
      adjustSubMenuPosition()
    }
  }, [state.showDropdown])

  if (breakpoint === 'mobile') {
    return (
      <MobileDropDownMenu
        menu={menu}
        index={index}
        state={state}
        widgetProps={widgetProps}
        toggleDropDown={toggleDropDown}
        handleOnMouseOver={handleOnMouseOver}
        contentLength={contentLength} />
    )
  }

  return (
    <div
      onMouseLeave={() => handleOnMouseOver(false, 'regular')}
      onMouseEnter={() => handleOnMouseOver(true, 'hover')}
      className={styles.dropdownWrapper}
    >
      <button
        className={cx(styles.menuButton, { [styles.lastButton]: index === contentLength - 1 })}
        style={state.buttonStyle}
        key={index}
        onClick={() => toggleDropDown(!state.showDropdown)}
      >
        {menu.name}
        <i className={cx('cleverstory-drop-down', styles.dropDownIcon, { [styles.showDropdown]: state.showDropdown })} />
      </button>
      {state.showDropdown &&
        <div ref={subMenuRef} className={styles.dropdownMenu}>
          {
            (menu.children || []).map((submenu, index) => {
              return (
                <SubMenuOption key={index} widgetProps={widgetProps} breakpoint="desktop" action={submenu.action} name={submenu.name} index={index} />
              )
            })
          }
        </div>
      }
    </div>
  )
}

const MobileDropDownMenu = ({ menu, index, state, widgetProps, handleOnMouseOver, toggleDropDown, contentLength }) => {

  var spacing = _.get(state.buttonStyle, 'marginBottom');
  let dropdownButtonStyle = {
    ...state.buttonStyle,
    marginBottom: '0px'
  }

  return (
    <div key={index}
      style={{ marginBottom: spacing }}
      onClick={() => toggleDropDown(!state.showDropdown)}
      onMouseLeave={() => handleOnMouseOver(state.showDropdown, 'regular')}
      onMouseEnter={() => handleOnMouseOver(state.showDropdown, 'hover')}
      className={cx(styles.mobileDropdownMenu)} id='menu'
    >
      <div className={cx(styles.mobileMenuButton, { [styles.lastButton]: index === contentLength - 1 })} style={dropdownButtonStyle}>
        <span className={styles.textContainer}>
          {menu.name}
        </span>
        <i className={cx('cleverstory-drop-down', { [styles.showDropdown]: state.showDropdown })} />
      </div>
      <ul className={cx(styles.listView, { [styles.active]: state.showDropdown })} id='listview'>
        {
          (menu.children || []).map((submenu, index) => {
            return (
              <SubMenuOption key={index} widgetProps={widgetProps} breakpoint='mobile' action={submenu.action} name={submenu.name} index={index} />
            )
          })
        }
      </ul>
    </div>
  )
}

const SubMenuOption = ({ name, index, widgetProps, breakpoint, action }) => {
  const actionExcutioner = useActionExectioner();

  const [subMenuStyle, setSubMenuStyle] = useState(getDropDownStyles(widgetProps, 'regular', breakpoint))

  const handleSubMenuHover = (active) => {
    const updatedStyle = getDropDownStyles(widgetProps, active, breakpoint);

    setSubMenuStyle(updatedStyle)
  }

  const handleClick = (e) => {
    if (action) {
      e.stopPropagation();
      actionExcutioner.execute(widgetProps, action);
    }
  }

  return (
    <div
      style={subMenuStyle}
      key={index}
      onMouseLeave={() => handleSubMenuHover('regular')}
      onMouseEnter={() => handleSubMenuHover('hover')}
      onClick={handleClick}
      className={styles.dropdownItem}
    >
      {name}
    </div>
  )
}

const menuButtonEquals = function (prevProps, nextProps) {
  const paths = ['className', 'widgetProps', 'breakpoint', 'menuContent', 'active'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const MenuButton = React.memo(MenuButtonComponent, menuButtonEquals);

/**
 * Generate Styles
 *
*/
function getDropDownStyles(widgetProperties, active, breakpoint) {
  var styles = {};

  if (!widgetProperties) {
    return styles;
  }

  const defaultProperties = _.get(widgetProperties, `desktop`);
  const defaultStyles = _.get(defaultProperties, `regular.menuStyles`, {});

  //font-color
  const colorRgb = _.get(defaultProperties, `${active}.dropdownColor`, null);
  const color = getColorStyles(colorRgb);
  styles = {
    ...styles,
    color: color
  }

  //background
  const backgroundRgb = _.get(defaultProperties, `${active}.dropdownBackground`, null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }

  styles['background'] = background;


  const font = _.get(defaultStyles, 'font', {});

  //font-family
  const fontFamily = _.get(font, 'fontFamily');
  if (fontFamily) {
    styles = {
      ...styles,
      fontFamily: fontFamily
    }
  }

  //line Height
  const layoutHeight = _.get(defaultProperties, 'layout.height');
  if (layoutHeight) {
    styles['lineHeight'] = layoutHeight;
  }

  //font-style
  const bold = _.get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }

  const italic = _.get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }

  const underline = _.get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }

  //line spacing
  const lineSpacingString = _.get(defaultProperties, 'regular.menuStyles.font.lineSpacing', null);
  if (lineSpacingString) {
    const lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }

  //Letter Spacing
  const letterSpacingString = _.get(defaultProperties, 'regular.menuStyles.font.letterSpacing', null);
  if (letterSpacingString) {
    const letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }

  //font-size
  const fontSizeString = breakpoint === 'desktop' ? _.get(defaultProperties, `regular.menuStyles.font.fontSize`, null) : 14;
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }

  styles['fontSize'] = fontSize;
  styles['justifyContent'] = 'center';
  styles['textAlign'] = 'center';


  //border
  const border = _.get(defaultProperties, `${active}.dropdownBorder`, {});
  const borderColor = _.get(border, `color`, null);

  const borderStyle = getBorderStyles(border, borderColor);
  styles = {
    ...styles,
    ...borderStyle
  }

  return styles;
}

function getStyles(properties, breakpoint, active) {
  var styles = {};

  if (!properties) {
    return styles;
  }

  const defaultProperties = _.get(properties, `desktop`);
  const deviceProperties = _.get(properties, `${breakpoint}`);
  const defaultStyles = _.get(defaultProperties, `regular.menuStyles`, {});

  //font-color
  const colorRgb = _.get(defaultProperties, `${active}.menuStyles.font.color`, null);
  const color = getColorStyles(colorRgb);
  styles = {
    ...styles,
    color: color
  }

  //background
  const backgroundRgb = _.get(defaultProperties, `${active}.menuStyles.background`, null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }

  styles['background'] = background;

  const font = _.get(defaultStyles, 'font', {});

  //font-family
  const fontFamily = _.get(font, 'fontFamily');
  if (fontFamily) {
    styles = {
      ...styles,
      fontFamily: fontFamily
    }
  }

  //font-size
  const fontSizeString = _.get(deviceProperties, 'regular.menuStyles.font.fontSize', null);
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }

  styles['fontSize'] = fontSize;

  //Letter Spacing
  const letterSpacingString = _.get(deviceProperties, 'regular.menuStyles.font.letterSpacing', null);
  if (letterSpacingString) {
    const letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }

  //line Height
  const layoutHeight = _.get(deviceProperties, 'layout.height');
  if (layoutHeight && breakpoint === 'desktop') {
    styles['lineHeight'] = layoutHeight;
  }

  //line spacing
  const lineSpacingString = _.get(deviceProperties, 'regular.menuStyles.font.lineSpacing', null);
  if (lineSpacingString) {
    const lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }


  //font-style
  const bold = _.get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }

  const italic = _.get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }

  const underline = _.get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }

  //border
  const border = _.get(defaultProperties, `${active}.menuStyles.border`, {});
  const borderColor = _.get(defaultProperties, `${active}.menuStyles.border.color`, null);

  const borderStyle = getBorderStyles(border, borderColor);
  styles = {
    ...styles,
    ...borderStyle
  }

  // spacing & padding
  const spacing = _.get(defaultProperties, 'padding');
  const horizontalPadding = _.get(defaultProperties, 'itemHorizontalPadding');
  const verticalPadding = _.get(defaultProperties, 'itemVerticalPadding');

  styles = {
    ...styles,
    paddingLeft: `${horizontalPadding}px`,
    paddingRight: `${horizontalPadding}px`,
    paddingTop: `${verticalPadding}px`,
    paddingBottom: `${verticalPadding}px`
  }

  if (breakpoint === 'mobile') {
    styles = {
      ...styles,
      marginBottom: `${spacing}px`,
    }
  } else if (breakpoint === 'desktop') {
    styles = {
      ...styles,
      marginRight: `${spacing}px`,
    }
  }

  //alignment
  const alignment = _.get(deviceProperties, 'alignment', {});

  var position = _.get(alignment, 'position', 'center');
  styles['textAlign'] = position;

  var margin = _.get(alignment, 'margin', 0);
  if (position === 'left') {
    styles = {
      ...styles,
      paddingLeft: `${margin}px`,
      justifyContent: 'flex-start'
    }
  } else if (position === 'right') {
    styles = {
      ...styles,
      paddingRight: `${margin}px`,
      justifyContent: 'flex-end'
    }
  }

  return styles;
}

export function getColorStyles(value) {
  if (!value) {
    return null;
  }

  const colorRgb = value;

  var color = 'inherit';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  return color;
}

export function getBorderStyles(value, colorRgb) {
  if (!value) {
    return null;
  }

  var styles = {};
  const topLeft = _.get(value, 'radius.topLeft', null);
  const topRight = _.get(value, 'radius.topRight', null);
  const bottomLeft = _.get(value, 'radius.bottomLeft', null);
  const bottomRight = _.get(value, 'radius.bottomRight', null);

  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }

  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }

  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }

  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }

  var color = 'transparent';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  styles['borderColor'] = color;

  const borderWidthString = _.get(value, 'width', null);
  var borderWidget = parseInt(borderWidthString) + 'px';

  styles['borderWidth'] = borderWidget;

  return styles;
}
